import { BiToolsRoute } from '@/modules/ta/dataexporter/bitools.constants';

export const router = [
  {
    path: `/${BiToolsRoute.BITOOLS}`,
    component: () => import(/* webpackChunkName: "bitools-page" */ './pages/BiToolsPage.vue'),
    props: true,
  },
  {
    path: `/${BiToolsRoute.BITOOLS}/powerbi`,
    component: () =>
      import(/* webpackChunkName: "bi-form-power-bi" */ './components/BiFormPowerBi.vue'),
    props: true,
  },
  {
    path: `/${BiToolsRoute.BITOOLS}/tableau`,
    component: () =>
      import(/* webpackChunkName: "bi-form-tableau" */ './components/BiFormTableau.vue'),
    props: true,
  },
];
